import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=7a7a4caf&scoped=true"
import script from "./Regulations.vue?vue&type=script&lang=js"
export * from "./Regulations.vue?vue&type=script&lang=js"
import style0 from "./Regulations.vue?vue&type=style&index=0&id=7a7a4caf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a4caf",
  null
  
)

export default component.exports